'use client';

import dayjs from 'dayjs';
import { useEffect } from 'react';
import { getSessionStorage, setSessionStorage } from 'viewup-lib/common';

export const CreateTabId = () => {
  useEffect(() => {
    if (getSessionStorage('tabId')) return;
    setSessionStorage('tabId', dayjs().valueOf());
  }, []);
  return <></>;
};
